export interface RateActionTypes {
  type: RateActions;
  payload?: any;
}

export enum RateActions {
  CREATE_RATE = "CREATE_RATE",
  GET_RATE_LIST = "GET_RATE_LIST",
  SET_RATE_LIST = "SET_RATE_LIST",
  SET_RATE_LIST_PAGE_COUNT = "SET_RATE_LIST_PAGE_COUNT",
  GET_RATE_DATA_BY_ID = "GET_RATE_DATA_BY_ID",
  SET_RATE_DATA_BY_ID = "SET_RATE_DATA_BY_ID",
  EDIT_RATE_DATA_BY_ID = "EDIT_RATE_DATA_BY_ID",
}
